import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Upload({ color = 'icon.primary', strokeWidth = '6', ...props }) {
  return (
    <IconBase viewBox='-4 -4 68 68' {...props}>
      <Path
        d='M58.5 45.832C58.5 52.8272 52.8285 58.4987 45.8333 58.4987H14.1667C7.1715 58.4987 1.5 52.8272 1.5 45.832'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M30.0026 1.50651V45.8398'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M14.1661 17.3398L30.0026 1.50334L45.8359 17.3398'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Upload.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Upload
